import { createApp } from 'vue'
import { createStore } from 'vuex'
import App from './App.vue'
import './assets/index.scss'
import './assets/css/font_3599222_pntnbk1ei9/iconfont.css'
import router from './routes/index'
import TDesign from 'tdesign-vue-next';
import storeState from './store'
import 'tdesign-vue-next/es/style/index.css'

const app = createApp(App)

const store = createStore(storeState)

app.use(TDesign)
app.use(store)

app.use(router).mount('#app')
